export default "__VITE_ASSET__B4cHHP6u__"